import { UserRoleDto } from '@/api/generated';

export type UsersListTranslation = {
  content: {
    dialog: {
      archiveAcceptedDevelopmentPaths: {
        button: {
          perform: string;
        };
        endingText: string;
        leadingText: string;
        pointsList: {
          first: string;
        };
      };
      getSsoUsersStats: {
        button: {
          download: string;
        };
      };
      resetPassword: {
        button: {
          cancel: string;
          close: string;
          copied: string;
          copy: string;
          reset: string;
        };
        description: string;
        error: {
          conflict: string;
          copyFailed: string;
          generic: string;
          rejected: string;
        };
        form: {
          generated: string;
          hidePassword: string;
          noEmail: string;
          passwordHint: string;
          passwordLabel: string;
          showPassword: string;
          temporary: string;
          typed: string;
        };
        result: {
          description: string;
          warning: string;
        };
        temporaryHint: string;
        title: string;
      };
      sendEmailToVerifySso: {
        button: {
          confirm: string;
          send: string;
        };
        content: {
          text: string;
        };
      };
    };
    table: {
      actions: string;
      email: string;
      enabled: string;
      firstName: string;
      lastName: string;
      resetPasswordButton: string;
      role: Record<UserRoleDto, string>;
      roles: string;
      rolesEmpty: string;
      sap: string;
      ssoCreated: string;
      verifiedInSso: string;
    };
  };
  form: {
    button: {
      archiveAcceptedDevelopmentPaths: string;
      menu: {
        downloadTemplateFile: string;
      };
      uploadUsers: string;
    };
    disabled: string;
    enabled: string;
    firstName: string;
    lastName: string;
    role: string;
    ssoCreated: string;
    ssoCreatedFalse: string;
    ssoCreatedTrue: string;
    verifiedInSso: string;
    verifiedInSsoFalse: string;
    verifiedInSsoTrue: string;
  };
};

export const usersListTranslation: UsersListTranslation = {
  content: {
    dialog: {
      archiveAcceptedDevelopmentPaths: {
        button: {
          perform: 'Perform',
        },
        endingText: 'Are you sure you want to do this?',
        leadingText: 'Performing this action will:',
        pointsList: {
          first: "move all accepted Development Plans to 'Archived' status.",
        },
      },
      getSsoUsersStats: {
        button: {
          download: "Download users' details",
        },
      },
      resetPassword: {
        button: {
          cancel: 'Cancel',
          close: 'Close',
          copied: 'Copied',
          copy: 'Copy',
          reset: 'Reset password',
        },
        description: 'Choose how to set the new password for {{name}}.',
        error: {
          conflict: 'The password of this account cannot be reset.',
          copyFailed: 'Could not copy the password. Select it and copy it manually.',
          generic: 'Could not reset the password. Try again.',
          rejected:
            'The password does not meet the requirements. Enter a different one or generate it automatically.',
        },
        form: {
          generated: 'Generate a password automatically',
          hidePassword: 'Hide password',
          noEmail: 'The user will not receive an email. Pass the password on yourself.',
          passwordHint: '8 to 128 characters.',
          passwordLabel: 'New password',
          showPassword: 'Show password',
          temporary: 'Temporary password',
          typed: 'Enter your own password',
        },
        result: {
          description: 'The password has been changed. Pass it on to the user.',
          warning:
            'The password is not stored anywhere. Once you close this window, it cannot be shown again.',
        },
        temporaryHint: 'The user will set their own password at the first sign-in.',
        title: 'Reset password',
      },
      sendEmailToVerifySso: {
        button: {
          confirm: 'Send',
          send: 'Send verification email',
        },
        content: {
          text: 'This action will send an account verification email to all inactive users. Are you sure you want to proceed?',
        },
      },
    },
    table: {
      actions: 'Actions',
      email: 'Email',
      enabled: 'Active',
      firstName: 'First Name',
      lastName: 'Last Name',
      resetPasswordButton: 'Reset password',
      role: {
        [UserRoleDto.Admin]: 'Administrator',
        [UserRoleDto.AdminCertification]: 'Certification Administrator',
        [UserRoleDto.AdminDevelopment]: 'Development Administrator',
        [UserRoleDto.AdminSuccession]: 'Succession Administrator',
        [UserRoleDto.Employee]: 'Employee',
        [UserRoleDto.Hrbp]: 'HRBP',
        [UserRoleDto.HrbpHq]: 'HQ HRBP',
        [UserRoleDto.ManagerP1]: 'Manager',
        [UserRoleDto.ManagerP2]: 'P2 Manager',
      },
      roles: 'Roles',
      rolesEmpty: 'No roles',
      sap: 'SAP',
      ssoCreated: 'SSO created',
      verifiedInSso: 'Verified in SSO',
    },
  },
  form: {
    button: {
      archiveAcceptedDevelopmentPaths: 'Archive development plans',
      menu: {
        downloadTemplateFile: 'Download template file',
      },
      uploadUsers: 'Upload users',
    },
    disabled: 'Inactive',
    enabled: 'Active',
    firstName: 'First Name',
    lastName: 'Last Name',
    role: 'Role',
    ssoCreated: 'SSO created',
    ssoCreatedFalse: 'Not created',
    ssoCreatedTrue: 'Created',
    verifiedInSso: 'Verified in SSO',
    verifiedInSsoFalse: 'Not verified',
    verifiedInSsoTrue: 'Verified',
  },
};
